import FingerprintJS from '@fingerprintjs/fingerprintjs';

const STORAGE_KEY = 'my_webapp_device_id';

export const getDeviceId = async () => {
  let deviceId = localStorage.getItem(STORAGE_KEY);

  if (!deviceId) {
    try {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      deviceId = result.visitorId;
    } catch (err) {
      console.warn('FingerprintJS failed, using UUID fallback');
      deviceId = crypto.randomUUID();
    }

    localStorage.setItem(STORAGE_KEY, deviceId);
  }

  return deviceId;
};
